module.exports = __webpack_public_path__ + "media/icons/mailing-instagram-a5cc5f0f.png";